<div class="code-wrapper">
  <div class="input-boxes">
    <span
      *ngFor="let item of [0, 1, 2, 3, 4, 5]"
      [class.active]="verifyCodeInput.value[item]"
      [class.focus]="focus && (item === 0 ? true : verifyCodeInput.value[item - 1])"
      >{{ verifyCodeInput.value[item] }}</span
    >
  </div>
  <input
    appAutoFocus
    #verifyCodeInput
    class="code-input"
    autocomplete="one-time-code"
    min="0"
    type="tel"
    (input)="onInput($event)"
    (focus)="focus = true"
    (blur)="focus = false"
    [value]="value"
  />
</div>
